import React from "react";
import salesTriggers from "../../assets/images/key-features/sales-triggers.png";
import orgChart from "../../assets/images/key-features/org-chart.png";
import directDials from "../../assets/images/key-features/directDials.png";
import reportAnalysis from "../../assets/images/key-features/report-analysis.png";

const features = [
  {
    title: "Organizational Chart",
    img: orgChart,
    bgColor: "tw-bg-[#F7F6FD]",
    bullets: [
      "Visualize your entire organization at a glance, empowering smarter business decisions.",
      "Map relationships, drive alignment, and unlock the full potential of your workforce.",
    ],
  },
  {
    title: "Direct Dials & Emails",
    img: directDials,
    bgColor: "tw-bg-[#EEF9FF]",
    bullets: [
      "Connect instantly with decision-makers—no barriers, just results.",
      "Boost conversions with verified contact details at your fingertips.",
    ],
  },
  {
    title: "Report & Analysis",
    img: reportAnalysis,
    bgColor: "tw-bg-[#F7FFF8]",
    bullets: [
      "Turn data into actionable insights that drive performance and growth.",
      "Uncover trends and optimize strategies with detailed, real-time reporting.",
    ],
  },
  {
    title: "Sales Triggers",
    img: salesTriggers,
    bgColor: "tw-bg-[#EEEFFF]",
    bullets: [
      "Never miss an opportunity—stay ahead with real-time sales alerts.",
      "Capitalize on key moments with instant notifications that fuel engagement.",
    ],
  },
];

const FeaturesList = () => {
  return (
    <section className="tw-py-20 lg:tw-py-24 tw-bg-slate-50/50 tw-border-t tw-border-solid tw-border-slate-100" id="key-features-list">
      <div className="tw-max-w-5xl tw-mx-auto tw-px-4 sm:tw-px-6 lg:tw-px-8">
        
        {/* Section Header */}
        <div className="tw-text-center tw-mb-16">
          <span className="tw-inline-flex tw-items-center tw-gap-2 tw-text-xs tw-font-bold tw-text-[#5D44FF] tw-uppercase tw-tracking-widest tw-mb-4 tw-bg-indigo-50 tw-px-4 tw-py-1.5 tw-rounded-full tw-border tw-border-solid tw-border-indigo-100">
            <span className="tw-w-1.5 tw-h-1.5 tw-rounded-full tw-bg-[#5D44FF] tw-inline-block" />
            Productivity Unleashed
          </span>
          <h2 className="tw-text-2xl sm:tw-text-3xl lg:tw-text-4xl tw-font-extrabold tw-text-slate-900 tw-leading-tight">
            Get More Done, While Doing Less
          </h2>
        </div>

        {/* 2x2 Grid */}
        <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-8">
          {features.map((item, idx) => (
            <div
              key={idx}
              className={`tw-group tw-relative tw-overflow-hidden ${item.bgColor} tw-border tw-border-solid tw-border-slate-100 tw-rounded-3xl tw-p-8 tw-shadow-sm hover:tw-shadow-xl hover:tw-scale-[1.02] tw-transition-all tw-duration-300 tw-text-left tw-flex tw-flex-col`}
            >
              {/* Title */}
              <h3 className="tw-text-lg tw-font-bold tw-text-slate-800 tw-mb-4">
                {item.title}
              </h3>

              {/* Bullets List */}
              <ul className="tw-space-y-3 tw-pl-0 tw-m-0 tw-mb-8">
                {item.bullets.map((bullet, bIdx) => (
                  <li key={bIdx} className="tw-flex tw-items-start tw-gap-2.5 tw-text-sm tw-text-slate-500 tw-leading-relaxed">
                    <span className="tw-text-[#5D44FF] tw-mt-1.5 tw-w-1.5 tw-h-1.5 tw-rounded-full tw-bg-[#5D44FF] tw-flex-shrink-0" />
                    <span>{bullet}</span>
                  </li>
                ))}
              </ul>

              {/* Showcase Image container at bottom */}
              <div className="tw-overflow-hidden tw-rounded-2xl tw-border tw-border-solid tw-border-slate-200/50 tw-bg-white/60 tw-flex tw-items-center tw-justify-center tw-mt-auto tw-w-full">
                <img
                  src={item.img}
                  alt={item.title}
                  className="tw-w-full tw-h-auto tw-object-contain hover:tw-scale-[1.02] tw-transition-transform tw-duration-300"
                  loading="lazy"
                />
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default FeaturesList;
